import React from 'react';

import { Dot } from 'components/table/Dot';

import { ChartsGrid } from '../ChartsGrid';
import { Donut, DonutProps, DataItem } from '../Donut/Donut';


export function TopDonutSection(props: {
  columns: string[],
  donutProps: DonutProps,
  getRowCells: (row: DataItem, i: number) => React.ReactNode[],
  sectionTitle: string,
}) {
  const colors = [
    '#ec7e41',
    '#6bb0e5',

    '#cbda7c',
    '#d974a9',

    '#ff5151',
    '#fed853',

    '#948dff',
    '#382458',
    '#007f84',
    '#ff1d62',
    '#57769c',
  ]
  return (
    <ChartsGrid
      title={props.sectionTitle}
      charts={[
        <Donut hideLegend {...props.donutProps} />,
        <table className="w-100">
          <thead>
            <tr style={{borderTop: '1px solid #e9ecef'}}>
              {props.columns.map((col, i) => <th key={i}>{col}</th>)}
            </tr>
          </thead>
          <tbody>
            {props.donutProps.data.length > 0 &&
              props.donutProps.data.map((row, i) => (
                <tr key={i} style={{borderTop: '1px solid #e9ecef'}}>
                  {props.getRowCells(row, i).map((cell, j) => (
                    <td key={j}>
                      {j === 0 && <Dot color={colors[i % 11]} />}
                      {cell}
                    </td>
                  ))}
                </tr>
              ))}
          </tbody>
        </table>
      ]}
    />
  );
}
